module.exports = {"available":"Свободно","booked":"Залата е запазена","occupied":"Occupied","booked-occupied":"Залата е запазена / Occupied","used":"used","until":"до","all-day":"цял ден","page_over_total":"Страница {page} от {total}","room-name":"Име На Зала","current-booking":"В Момента","next-booking":"Следващ","unknown":"Неизвестно","floors":"етажи","today":"днес","no_bookings":"Днес няма насрочени срещи","no_information":"Няма информация","description":"Description","capacity":"Capacity","allocated":"Allocated","booked-occupied-allocated":"Залата е запазена / Occupied / Allocated"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/bg.json
// module id = ROM1
// module chunks = 2